import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, darken, Typography } from '@mui/material';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useOrgan } from '../hooks/useOrgan';
import { organizationPrimaryColors } from '../layouts/PermanentSidebarMUI';

const AccordionControlled = ({ children, titleButton, defaultExpanded = false }) => {
    const { selectedOrgan } = useOrgan();
    const primaryColor = selectedOrgan?.name
        ? organizationPrimaryColors[selectedOrgan.name.toUpperCase()] || organizationPrimaryColors.ALUCOM
        : organizationPrimaryColors.ALUCOM;
    return (
        <Accordion defaultExpanded={defaultExpanded}>
            <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} className="text-white" />}
                aria-controls="panel3-content"
                id="panel3-header"
                sx={{
                    backgroundColor: primaryColor,
                    color: '#ffffff',
                    borderRadius: '4px',
                    ':hover': { backgroundColor: darken(primaryColor, 0.15) },
                }}
            >
                <Typography component="h6" className="fw-bold">
                    {titleButton}
                </Typography>
            </AccordionSummary>

            <AccordionDetails>{children}</AccordionDetails>
        </Accordion>
    );
};

export default AccordionControlled;
